import apiInfraction from "../axios/apiInfraction";

class InfractionService {

  static async getByQuery(Query, Page) {
    try {
      let body = {query: Query, page: Page}
      const response = await apiInfraction.post(`/infractions/byquery`, body);
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error fetching infractions by query:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getByState(state) {
    try {
      const response = await apiInfraction.get(`/infractions/get-filtered/${state}`);
      if (response.status < 400) {
        return { success: true, data: response.data.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error fetching infractions by state:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getByAct(actNumber) {
    try {
      const response = await apiInfraction.get(`/infractions/get-by-act/${actNumber}`);
      if (response.status < 400) {
        return { success: true, data: response.data.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error fetching infractions by actNumber:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getByInternal(internalNumber) {
    try {
      const response = await apiInfraction.get(`/infractions/get-by-internal/${internalNumber}`);
      if (response.status < 400) {
        return { success: true, data: response.data.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error fetching infractions by internalNumber:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getByCuil(cuil) {
    try {
      const response = await apiInfraction.get(`/infractions/get-by-cuil/${cuil}`);
      if (response.status < 400) {
        return { success: true, data: response.data.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error fetching infractions by cuil:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getByDateRange(fromDate, toDate) {
    try {
      const response = await apiInfraction.get(`/infractions/get-by-date-range/${fromDate}&${toDate}`);
      if (response.status < 400) {
        return { success: true, data: response.data.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error fetching infractions by cuil:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }
  static async getAllInfractions() {
    try {
      const response = await apiInfraction.get("/infractions/getall");
      if (response.status === 200) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error fetching infractions:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getOwnInfractions(page) {
    try {
      const response = await apiInfraction.get(`/infractions/owns/${page}`);
      if (response.status === 200) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error fetching infractions:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getInfractionById(id) {
    try {
      const response = await apiInfraction.get(`/infractions/by-id/${id}`);
      if (response.status === 200) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error fetching infractions:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async isAvailableActNumber(actNumer) {
    try {
      const response = await apiInfraction.get(`/infractions/is-disponible-act-number/${actNumer}`);
      if (response.status === 200) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error fetching available act number:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async isAvailableInternalNumber(internalNumber) {
    try {
      const response = await apiInfraction.get(`/infractions/is-disponible-internal-number/${internalNumber}`);
      if (response.status === 200) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error fetching available internal number:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async updateInfraction(body) {
    try {
      const response = await apiInfraction.put(`/infractions/update`,body);
      if (response.status === 200) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error Updating infraction:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async AssignInternal(infractionId, internalNumber) {
    try {
      const body = {
        id: infractionId,
        internalNumber: internalNumber
      };
      const response = await apiInfraction.put(`/infractions/assign-internal`, body);
      if (response.status === 200) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error Updating infraction:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async AssignTitular(infractionId, titular_cuil) {
    try {
      const body = {
        id: infractionId,
        infractor_cuil: titular_cuil
      };
      const response = await apiInfraction.put(`/infractions/assign-titular`, body);
      if (response.status === 200) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error Updating infraction:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async AssignVehicle(infractionId, type, brand, model, color) {
    try {
      const body = {
        id: infractionId,
        vehicle: type,
        brand: brand,
        model: model,
        color: color
      };
      const response = await apiInfraction.put(`/infractions/assign-vehicle`, body);
      if (response.status === 200) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error Updating infraction:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async updateCover(body) {
    try {
      const response = await apiInfraction.put(`/infractions/update-cover`,body);
      if (response.status === 200) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error Updating infraction:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async createInfraction(body) {
    try {
      const response = await apiInfraction.post(`/infractions/upload`,body);
      if (response.status === 201) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error uploading infraction:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async createObservation(body) {
    try {
      const response = await apiInfraction.post(`/infractions/add-observation`,body);
      if (response.status < 400) {
        return { success: true, data: response.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error Updating infraction:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }

  static async getHistoryByCuil(cuil) {
    try {
      const response = await apiInfraction.get(`/infractions/history-by-cuil/${cuil}`);
      if (response.status < 400) {
        return { success: true, data: response.data.data };
      }
      return {
        success: false,
        message: "Unexpected response status",
        status: response.status,
      };
    } catch (error) {
      console.error("Error fetching infractions by cuil:", error);
      return {
        success: false,
        message: error.message,
        status: error.response?.status || 500,
      };
    }
  }
}

export default InfractionService;
